"use client";

import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { FaLaptopCode, FaUsers, FaCertificate } from "react-icons/fa";
import "../courses/free-courses.css";

// Register GSAP plugins
if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}

const CourseFeatureSection = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const featuresRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Animate section
      gsap.fromTo(
        sectionRef.current,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power3.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 90%",
          },
        }
      );

      // Animate title
      gsap.fromTo(
        titleRef.current,
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          delay: 0.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: titleRef.current,
            start: "top 90%",
          },
        }
      );

      // Animate features
      gsap.fromTo(
        ".feature-box",
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.15,
          ease: "power3.out",
          scrollTrigger: {
            trigger: featuresRef.current,
            start: "top 90%",
          },
        }
      );
    });

    return () => ctx.revert();
  }, []);

  return (
    <div className="bg-bg-pattern bg-cover bg-center w-full relative">
      <div className="container mx-auto px-4 features-container">
        <div ref={sectionRef} className="features-wrapper">
          <h2 ref={titleRef} className="features-title">
            WELL STRUCTURED COURSES TO <span>ENHANCE</span> YOUR SKILLS
          </h2>

          <div ref={featuresRef} className="features-grid">
            <div className="feature-box">
              <div className="mr-4">
                <FaLaptopCode className="feature-icon" />
              </div>
              <div>
                <h3 className="feature-title">MSME Registered</h3>
                <p className="feature-description">Certificates</p>
              </div>
            </div>
            
            <div className="feature-box">
              <div className="mr-4">
                <FaUsers className="feature-icon" />
              </div>
              <div>
                <h3 className="feature-title">Lifetime access</h3>
                <p className="feature-description">to community</p>
              </div>
            </div>
            
            <div className="feature-box">
              <div className="mr-4">
                <FaCertificate className="feature-icon" />
              </div>
              <div>
                <h3 className="feature-title">Lifetime access</h3>
                <p className="feature-description">to community</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseFeatureSection;
